






































import { Component, Prop, Watch } from "vue-property-decorator";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import WorkerSkillDto from "@/models/WorkerSkills/WorkerSkillDto";
import WorkerSkillStatus from "@/models/WorkerSkills/WorkerSkillStatus";

@Component({
  name: "WorkerSkillEdit",
})
export default class extends GiganautVueDialog {
  
  public dialog = false;

  @Prop({required: true})
  workerSkillId: string;
  workerSkill: WorkerSkillDto = new WorkerSkillDto();
  isVerified = false;

  
 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      //We need to fetch the latest copy - passing this in as a prop means updated at becomes stale on send edit
      const workerSkill = WorkerDetailsModule.skills.find((findWorkerSkill: WorkerSkillDto) => findWorkerSkill.id === this.workerSkillId);
      this.workerSkill = this.workerSkill = JSON.parse(JSON.stringify(workerSkill));
      this.isVerified = (this.workerSkill.status === WorkerSkillStatus.Verified);
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    if (this.isVerified) {
      this.workerSkill.status = WorkerSkillStatus.Verified;
    } else {
      this.workerSkill.status = WorkerSkillStatus.Pending;
    }
    await WorkerDetailsModule.editSkill(this.workerSkill);
    this.dialog = false;
  }
}
